import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { fetchGetTranslationAction } from 'actions/documentMeta';

export interface IGetLang {
  fetchGetTranslation: () => void;
}

export function GetLang({ fetchGetTranslation }: IGetLang) {
  fetchGetTranslation();
  return null;
}

const mapDispatch = (dispatch: Dispatch) => ({
  fetchGetTranslation: () => dispatch(fetchGetTranslationAction()),
});

export default connect(null, mapDispatch)(GetLang);
